import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import noop from 'hs-lodash/noop';
import { useState } from 'react';
import UIClickable from 'UIComponents/button/UIClickable';
import UISelect from 'UIComponents/input/UISelect';
import FullScreenSearch from './FullScreenSearch';
/**
 * Mobile Select
 *
 * This component renders the Mobile Dropdown component that when clicked
 * shows the full screen search component.
 *
 */

export const MobileDropdown = ({
  buttonStyle = {},
  selected,
  searchPlaceholder,
  illustrationName = '',
  illustrationCaption = '',
  illustrationWidth = 60,
  seleniumKey,
  noMatchesOption = {
    text: '',
    value: '',
    help: ''
  },
  options = [],
  loadOptions,
  searchAutofocus = true,
  showOptionsWhenNullSearchValue = true,
  onClose = noop,
  onSelectChange,
  onInputChange,
  disabled,
  isFullScreenOpen = false,
  renderOption
}) => {
  const [showDropdown, setShowDropDown] = useState(isFullScreenOpen);
  const [selectedText, setSelectedText] = useState(selected);

  const SelectButton = ({
    onClick,
    style
  }) => {
    return /*#__PURE__*/_jsx(UIClickable, {
      disabled: disabled,
      style: style,
      onClick: onClick,
      children: /*#__PURE__*/_jsx(UISelect, {
        anchorType: 'input',
        "data-selenium": `${seleniumKey}-mobile-search`,
        disabled: disabled,
        inputValue: selectedText,
        placeholder: searchPlaceholder
      })
    });
  };

  const closeFullScreenSearch = () => {
    setShowDropDown(false);
    onClose();
  };

  const openFullScreenSearch = () => {
    setShowDropDown(true);
  };

  const onChange = option => {
    setSelectedText(option.text);
    closeFullScreenSearch();
    onSelectChange(option);
  };

  return /*#__PURE__*/_jsxs("div", {
    children: [showDropdown && /*#__PURE__*/_jsx(FullScreenSearch, {
      allOptions: options,
      illustrationCaption: illustrationCaption,
      illustrationName: illustrationName,
      illustrationWidth: illustrationWidth,
      loadOptions: loadOptions,
      noMatchesOption: noMatchesOption,
      searchAutofocus: searchAutofocus,
      renderOption: renderOption,
      searchPlaceholder: searchPlaceholder,
      seleniumKey: seleniumKey,
      showOptionsWhenNullSearchValue: showOptionsWhenNullSearchValue,
      onClose: closeFullScreenSearch,
      onInputChange: onInputChange,
      onSelectOption: onChange
    }), /*#__PURE__*/_jsx("div", {
      style: {
        position: 'relative'
      },
      children: /*#__PURE__*/_jsx(SelectButton, {
        style: Object.assign({
          position: 'relative'
        }, buttonStyle),
        onClick: openFullScreenSearch
      })
    })]
  });
};